import type {
  CertificatRamonagePayload,
  CertificatRamonagePrefill,
  ICompany,
  ICustomer,
  PlatformUserStyle,
} from "@mytour/shared";
import {useRef} from "react";
import {Alert, Modal, ModalBody} from "reactstrap";
import type {CertificateCustomerQueries} from "../types";
import {CertificateWizard} from "./CertificateWizard";

type Props = {
  customerQueries: CertificateCustomerQueries;
  company: ICompany;
  platformUserStyle: PlatformUserStyle;
  defaultValues?: CertificatRamonagePrefill;
  customer: ICustomer;
  intervenantName?: string;
  error?: string | null;
  onSave: (data: CertificatRamonagePayload, sendEmail: boolean) => Promise<void>;
  onClose: () => void;
};

export function CertificateWizardModal({
  customerQueries,
  company,
  platformUserStyle,
  defaultValues,
  customer,
  intervenantName,
  onSave,
  error,
  onClose,
}: Props) {
  const interactionBlockedRef = useRef(false);

  return (
    <Modal
      isOpen={true}
      id="onboarding-certificat-ramonage"
      style={{height: "calc(100% - var(--bs-modal-margin) - var(--bs-modal-margin))"}}
      autoFocus={false}
      toggle={() => {
        if (!interactionBlockedRef.current) {
          onClose();
        }
      }}
    >
      <ModalBody style={{display: "flex", flexDirection: "column", height: "100%"}}>
        {error && <Alert color="danger">{error}</Alert>}
        <div
          style={{
            display: "grid",
            gridTemplateRows: "1fr",
            flex: 1,
            minHeight: 0,
            width: "100%",
          }}
        >
          <CertificateWizard
            customerQueries={customerQueries}
            company={company}
            platformUserStyle={platformUserStyle}
            defaultValues={defaultValues}
            customer={customer}
            intervenantName={intervenantName}
            onInteractionBlockedChange={(blocked) => {
              interactionBlockedRef.current = blocked;
            }}
            onClose={onClose}
            onSave={onSave}
          />
        </div>
      </ModalBody>
    </Modal>
  );
}
